
































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import http from '@/methods/http.ts';

@Component
export default class CategoriesMini extends Vue {
    categories = [];

    getCategories() {
        http('categories/medicina/first_child', 'get', false, {}).then(r => {
            this.categories = r.data.children;
        })
    }

    created = this.getCategories();
}

